module.exports = __webpack_public_path__ + "static/media/undraw_sync_re_492g.1fafba1c.svg";